import { default as palette } from "../../../../core/palette";

export const themeColour = palette.grape[500];
